import { AjaxStreamCallback, AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'

export interface TemplateChatResponse {
  message?: string
  updatedHtml?: string
  fileId?: string // File ID for template persistence
  modifications?: {
    applied: number
    failed: number
    failedSelectors: string[]
    htmlChanged: boolean
  }
  done?: boolean
  error?: string
}

export type TemplateChatCallback = (response: TemplateChatResponse | null) => void

export const streamTemplateChatResponse = (
  communityId: string,
  payload: any,
  callback: TemplateChatCallback
) => {
  const url = `${AjaxWrapper.getServerUrl()}/ai/${communityId}/template-chat`

  // Buffer incomplete SSE data across chunks (large payloads like updatedHtml get fragmented)
  let buffer = ''

  const responseParser: AjaxStreamCallback = (success: boolean, chunk: string) => {
    if (!chunk) {
      callback(null)
      return
    }

    if (!success) {
      callback({
        done: true,
        error: chunk,
      })
      return
    }

    // Accumulate chunks and split on SSE event boundaries (\n\n)
    buffer += chunk
    const events = buffer.split('\n\n')

    // The last element may be an incomplete event — keep it in the buffer
    buffer = events.pop() || ''

    events.forEach((event) => {
      const lines = event.split('\n')
      lines.forEach((line) => {
        if (line.startsWith('data: ')) {
          try {
            const jsonStr = line.substring(6) // Remove "data: " prefix
            const data = JSON.parse(jsonStr)
            callback(data)
          } catch (e) {
            // Ignore parse errors
          }
        }
      })
    })
  }

  AjaxWrapper.stream(url, HttpMethod.POST, payload, responseParser)
}
